<template>
    <div class="setting__tips">
        <pd-icon icon="tips-o" />
        <span @click="handleClick" v-html="parsedContent" />
    </div>
</template>
<script>
import markdown from 'micro-down'

// 基础提示组件，支持 markdown 语法
export default {
    name: 'CommonTips',
    props: {
        content: {
            type: String,
            default: '',
        },
    },
    computed: {
        parsedContent() {
            return markdown.parse(this.content)
        },
    },
    methods: {
        handleClick(e) {
            const href = e.target.getAttribute('href')
            //如果事件源是a标签
            if (e.target.tagName === 'A') {
                //如果是外链
                if (href.startsWith('http://') || href.startsWith('https://')) {
                    e.preventDefault()
                    window.open(href, '_blank')
                } else {
                    //应用内跳转
                    this.$router.push(href)
                }
            }
        },
    },
}
</script>
<style lang="less" scoped>
.setting__tips {
    background: rgba(38,110,255,0.1);
    color: #666666;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items: flex-start;
    padding: 6px 15px;

    .pd-icon{
        color: #266EFF;
        font-size: 14px;
        margin-right: 10px;
        margin-top: 3px;
    }
}
</style>
